<template>
  <div class="body-box">
    <div
      class="contents"
      v-if="searchList.brand.length > 0 || searchList.data.length > 0"
    >
      <p class="search-title">搜索结果“{{ searchinfos }}”</p>
      <!--<p class="search-title-lable">相关关键词：<a>行星减速机 showgoods</a><a>谐波减速机</a><a>RV减速机</a></p>-->
      <div class="search-item" v-if="searchList.data.length > 0">
        <div
          class="search-item-title"
          @click="isshowgoods()"
          :class="{ 'search-item-title-hidden': showgoods }"
        >
          <span v-if="searchList.data.length > 0">产品</span
          ><span v-else>产品</span>（{{ searchList.total }}个结果）<i
            v-if="showgoods"
            class="icon iconfont icon-xiangxiazhankai"
          ></i>
          <i v-else class="icon iconfont icon-youjiantou"></i>
        </div>
        <div class="search-item-goods-list" v-if="showgoods">
          <user-search-goods-list
            ref="goodslist"
            :goodslistall="searchList"
            @getgoodslist="getgoodslist"
            :showpage="showpage"
            :pagesize="pagesize"
            :iconon="iconon"
            :iconoff="iconoff"
            @editgoods="editgoods"
            :total="searchList.total"
          />
        </div>
      </div>
      <div class="search-item" v-if="searchList.brand.length > 0">
        <div class="search-item-title" @click="isshowbrand()">
          品牌（{{ searchList.brand.length }}个结果）<i
            v-if="showbrand"
            class="icon iconfont icon-xiangxiazhankai"
          ></i>
          <i v-else class="icon iconfont icon-youjiantou"></i>
        </div>
        <div
          class="search-item-goods-list search-item-goods-list-showbrand"
          v-if="showbrand"
        >
          <div
            class="search-item-goods-list-item"
            v-for="(item, index) in searchList.brand"
            :key="index"
            :class="{ 'left-itme': (index + 1) % 5 == 0 }"
          >
            <router-link :to="{ name: 'brand', params: { id: item.id } }">
              <div class="search-item-goods-list-item-img">
                <img :src="item.image" />
              </div>
              <p>{{ item.name }}</p>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="contents" v-else>
      <p class="search-title search-title-nogoods">
        搜索结果“{{ searchinfos }}”?
      </p>
      <p class="search-title-lable search-title-lable-nogoods">
        抱歉，没有找到“{{ searchinfos }}”的相关结果
      </p>
      <div class="contents-one">
        <p class="contents-one-title">搜索提示：</p>
        <p class="contents-one-lable">检查您的搜索关键词</p>
        <p class="contents-one-lable">扩大您的搜索范围</p>
        <!-- <p class="contents-one-lable">搜索产品编号时，搜索其中的一部分，例如前3-4个字母，扩大搜索结果范围</p> -->
      </div>
      <div
        class="search-item"
        v-if="searchList && searchList.reco && searchList.reco.length > 0"
      >
        <div
          class="search-item-title"
          :class="{ nogoods: searchList.reco.length > 0 }"
          @click="isshowgoods()"
        >
          <span v-if="searchList.reco.length > 0">相关推荐</span
          ><span v-else>产品</span>（{{ searchList.total }}个结果）<i
            v-if="showgoods"
            class="icon iconfont icon-xiangxiazhankai"
          ></i>
          <i v-else class="icon iconfont icon-youjiantou"></i>
        </div>
        <div class="search-item-goods-list" v-if="showgoods">
          <user-search-goods-list
            ref="goodslist"
            :goodslistall="searchList"
            @getgoodslist="getgoodslist"
            :showpage="showpage"
            :pagesize="pagesize"
            :iconon="iconon"
            :iconoff="iconoff"
            @editgoods="editgoods"
            :total="searchList.total"
          />
        </div>
      </div>

      <!--
         <div v-else class="contents-two contents-one">
            <p class="contents-one-title">需要获取帮助？</p>
            <div class="contents-two-info">
                <div class="contents-two-info-left">
                    <p class="contents-one-lable">检查您的搜索关键词</p>
                    <p class="contents-one-lable-info"><i class="icon iconfont icon-dianhua"></i>+86 （22）400-653-7789</p>
                </div>
                <div class="contents-two-info-left">
                    <p class="contents-one-lable">邮件联系（我们会在2天内回复）</p>
                    <p class="contents-one-lable-info"><i class="icon iconfont icon-youxiang1"></i>shejiyuan@tjchenxing.com</p>
                </div>
            </div>
         </div>
         -->
    </div>
    <!-- 有搜索产品时显示右侧对比栏（收起/展开规则与 list 页一致） -->
    <comparison v-if="searchList.data.length > 0" />
  </div>
</template>

<script>
import UserSearchGoodsList from "../components/user/UserSearchGoodsList.vue";
import Comparison from "../components/goods/Comparison.vue";
import { mapGetters, mapActions } from "vuex";
import { Message } from "element-ui";
export default {
  data() {
    return {
      searchinfos: "",
      title: "",
      pagesize: 20,
      iconon: "icon iconfont icon-shoucang1",
      iconoff: "el-icon-star-off",
      showpage: true,
      searchList: {
        brand: [],
        data: []
      },
      page: 1,
      showgoods: true,
      showbrand: true
    };
  },
  components: {
    UserSearchGoodsList,
    Comparison
  },
  methods: {
    isshowgoods() {
      this.showgoods = !this.showgoods;
    },
    isshowbrand() {
      this.showbrand = !this.showbrand;
    },

    showMsg(title) {
      this.title = title;
    },
    getgoodslist(val) {
      this.$api.goods
        .getSearch(this.searchinfos, this.UserId, val)
        .then(res => {
          this.searchList = res.data.datas;
        });
    },
    ...mapActions(["saveKeyword", "savekeywordtime"]),
    editgoods(goodsid) {
      //console.log("收藏商品"+goodsid)
      var index = this.searchList.data.findIndex(item => {
        if (item.id == goodsid) {
          return true;
        }
      });
      this.$api.goods
        .getStoreAdd(goodsid, (this.searchList.data[index].store + 1) % 2)
        .then(res => {
          if (res.data.errno == 0) {
            if (this.searchList.data[index].store == 1) {
              this.$set(this.searchList.data[index], "store", 0);
              this.$FUnitls.showInfo("取消收藏", "info");
            } else {
              this.$set(this.searchList.data[index], "store", 1);
              this.$FUnitls.showInfo("已收藏", "info");
            }
            // var options={
            //   message:"收藏成功",
            // }
            // Message.success(options)
          } else {
            var options = {
              message: res.data.errmsg
            };
            Message.error(options);
          }
        });
    }
  },
  mounted() {
    this.searchinfos = this.Keywords;
    if (this.$route.params.searchinfo) {
      this.saveKeyword(this.$route.params.searchinfo);
      this.$api.goods
        .getSearch(this.$route.params.searchinfo, this.UserId)
        .then(res => {
          this.searchList = res.data.datas;
        });
    }
  },
  metaInfo: {
    title: this.searchinfos,
    meta: [
      { name: "keywords", content: "页面关键字" },
      { name: "description", content: "页面描述" }
    ]
  },
  watch: {
    Keywords(val) {
      this.searchinfos = val.trim();
      if (val.trim()) {
        // 防抖
        // 清除计时器
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.$api.goods.getSearch(val.trim(), this.UserId).then(res => {
            this.searchList = res.data.datas;
          });
        }, 1000);
      }
    },
    keywordtime() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.$api.goods.getSearch(this.searchinfos, this.UserId).then(res => {
          this.searchList = res.data.datas;
        });
      }, 1000);
    }
  },
  computed: {
    ...mapGetters(["Keywords", "UserId", "keywordtime"])
  }
};
</script>

<style scoped>
.search-item-goods-list-showbrand {
  /* display: flex;
    flex-wrap: wrap;
        justify-content: space-around; */
}
.search-item-title .icon {
  font-size: 30px;
  float: right;
  margin-right: 30px;
  cursor: pointer;
}
.nogoods {
  margin-top: 25px;
}
.body-box {
  background-color: #f3f5f7;
  /* overflow: hidden; */
  padding-bottom: 50px;
}
.body-box .search-title {
  font-size: 24px;
  color: #666666;
  margin-top: 60px;
  margin-bottom: 40px;
}
.body-box .search-title-nogoods {
  font-size: 24px;
  color: #666666;
  margin-top: 60px;
  margin-bottom: 10px;
}
.body-box .search-title-lable {
  font-size: 12px;
  color: #707070;
  margin-top: 11px;
  margin-bottom: 40px;
}
.body-box .search-title-lable-nogoods {
  font-size: 12px;
  color: #707070;
  margin-top: 11px;
  margin-bottom: 20px;
}
.body-box .search-title-lable a {
  color: #2655ae;
  margin-right: 10px;
}
.search-item-title {
  width: 1193px;
  height: 60px;
  background-color: #fff;
  line-height: 60px;
  font-size: 24px;
  color: #707070;
  padding-left: 7px;
  margin-bottom: 25px;
}
.search-item-title-hidden {
  margin-bottom: 0;
}
.search-item-goods-list {
  margin-bottom: 50px;
  overflow: hidden;
}
/* .search-item-goods-list-item,.search-item-goods-list-item img{
    width: 188px;
    height: 120px;
    
  } */
.search-item-goods-list-item {
  width: 18%;
  float: left;
  margin-right: 2.5%;
  margin-bottom: 10px;
}
.search-item-goods-list-item p {
  color: #666;
}
.left-itme {
  margin-right: 0;
}
.search-item-goods-list-item-img {
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 5px;
}
.search-item-goods-list-item-img img {
  width: 100%;
}
.search-item-goods-list-item-right {
  margin-right: 0;
}
.search-item-goods-list-item p {
  text-align: center;
}
.contents-one-title {
  color: #333333;
  font-size: 12px;
  line-height: 25px;
  letter-spacing: 0.579597px;
}
.contents-one-lable {
  color: #737373;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 3px;
}
.contents-two-info {
  overflow: hidden;
}
.contents-two-info-left {
  float: left;
  margin-right: 89px;
}
.contents {
  min-height: 900px;
}
.contents-one {
  background-color: #fff;
  width: 1142px;
  padding: 12px 29px;
}
.contents-two {
  margin-top: 26px;
}
.contents-one-lable-info {
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  /* identical to box height, or 150% */

  color: #2655ae;
}
.contents-one-lable-info .icon {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/search.vue